import { useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IGroupType } from '../../../store/modules/facility/i-facility';
import { useStore } from '../../providers/store-provider/state.context';
import { useActions } from '../../providers/actions-provider/actions.context';
import capitalize from '../../../utils/capitalize';
import createBreadcrumbsFromRoute from '../../../utils/create-breadcrumbs';
import useQuery from '../../../utils/useQuery';

const findRootGroup = (groupTypesData: IGroupType[]) => groupTypesData.find(
  (type) => type.groupType_id === null,
);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useCreateGroupData = () => {
  const { location: { pathname } } = useHistory();
  const { facilityActions } = useActions();
  const {
    groupTypes,
    groups,
    currentUser,
    mapOrigin,
  } = useStore();

  const query = useQuery();
  const isEdit = pathname.includes('edit');
  const group = query.get('group');
  const subGroup = query.get('groupType');
  const childrenLength = Number(query.get('children'));
  const defaultGroup = group && groups.data[group];
  const groupTypesData = Object.values(groupTypes.data);
  const groupType = groupTypesData
    .find((type) => type.groupType_id?.toString() === subGroup);
  const isRoot = group === 'root' && subGroup === 'root';
  useEffect(() => {
    // facilityActions.resetMapValues();
    facilityActions.getGroups();
    facilityActions.getGroupTypes();
    if (isEdit) {
      facilityActions.resetMapValues().then(() => {
        facilityActions.getMapOrigin(group);
      });
    }
  }, []);

  useEffect(() => {
    if (!mapOrigin.loading
      && mapOrigin.data.id
      && group
      && group === `${mapOrigin.data.group_id}`) {
      facilityActions.getMapImage(mapOrigin.data.group_id);
    }
  }, [mapOrigin]);

  useEffect(() => {
    if (!groups.loaded) {
      if (group && !childrenLength && !isRoot) {
        facilityActions.getZones(group);
      }
    }
  }, [groups]);

  return useMemo(() => {
    const initialValues = 'test';
    return ({
      title: isEdit && defaultGroup ? defaultGroup.name : `New ${capitalize(groupType ? groupType.name : findRootGroup(groupTypesData)?.name ?? '')}`,
      query,
      group,
      subGroup,
      groupType,
      initialValues,
      isRoot,
      findRootGroup,
      groupTypesData,
      isEdit,
      routes: createBreadcrumbsFromRoute(pathname, groups.data, currentUser.data.tenant || ''),
      defaultGroup,
      showDeleteBtn: isEdit && childrenLength === 0 && defaultGroup
        && !defaultGroup?.zones?.data?.length,
      id: defaultGroup ? defaultGroup.id : '',
      defaultSubGroup: !isRoot && groupType ? groupType
        : findRootGroup(groupTypesData),
    });
  }, [pathname, groupTypes, groups]);
};

export default useCreateGroupData;
